import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import aboutimg from "../../../Image/aboutimg.png"
import { BsJournals, BsClock } from 'react-icons/bs';
import { FaUserFriends } from 'react-icons/fa';
import { SlArrowLeft } from 'react-icons/sl';
import axios from 'axios';
import { BASE_URL } from '../../../insightConfig/insightConfig';

const NeetTestSeriesCards = ({ testSeries, heading }) => {
    const location = useLocation();
    const navigate = useNavigate();
    console.log(testSeries);
    const [subjects, setSubjects] = useState([]);
    function isValidUrl(string) {
        try {
            new URL(string);
            return true;
        } catch (_) {
            return false;
        }
    }
    console.log(subjects);

    useEffect(() => {
        axios.get(BASE_URL + '/neet/user/subjects').then(res => {
            setSubjects(res.data.data);
            console.log(res.data.data);
        }).catch((error) => {
            console.log(error);
        })

    }, [])
    return (
        <>
            <div className='AllCardBackground'>
                <div className="d-flex justify-content-between align-items-center p-2 py-1 mb-3 bg-light border rounded shadow-sm">
                    <button
                        className="btn btn-sm"
                        style={{
                            backgroundColor: '#17a2b8',
                            color: 'white',
                            fontWeight: 'bold',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px',
                            padding: '4px 12px',
                            border: 'none',
                            borderRadius: '4px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                            cursor: 'pointer'
                        }}
                        onClick={() => navigate(-1)}
                    >
                        <SlArrowLeft /> Back
                    </button>
                    <h2 className="mb-0 fs-5" style={{ color: 'rgb(183, 6, 6)', fontWeight: 600, letterSpacing: '0.5px', textShadow: '0 1px 1px rgba(0,0,0,0.1)', lineHeight: '1.2' }}>{heading}</h2>
                    <Link to={'/StudentDashboard'} state={{ prePath: location.pathname, moduleName: 'neet' }} style={{ textDecoration: 'none', color: '#17a2b8', fontWeight: 'bold' }}>Dashboard</Link>
                </div>
                {/* <h1
                    className="fw-bold fs-4 text-center py-0 my-0 text-uppercase text-danger border-bottom border-2 mb-3"
                >
                    {heading}
                </h1> */}

                <div className="px-3 d-flex justify-content-center" style={{ textAlign: "justify", lineHeight: "1.8" }}>
                    <ul className="mb-0 ps-3">
                        <li className="mb-2">
                            The <strong>Test Series</strong> will help you set micro-targets for each subject,
                            ensuring consistent preparation and timely completion of the syllabus.
                        </li>
                        <li className="mb-2">
                            Special focus is given to <strong>NCERT textbooks</strong> to keep your preparation
                            aligned with the most relevant and high-yield sources for NEET.
                        </li>
                        <li className="mb-2">
                            All questions are <strong>exclusively handpicked</strong> and designed by expert
                            faculty members for maximum authenticity and relevance.
                        </li>
                        <li className="mb-2">
                            The Test Series enables you to assess your preparation through the most authentic
                            <strong> NCERT-based and “NTA Level” questions</strong>.
                        </li>
                        <li className="mb-2">
                            <strong>Detailed solutions</strong> for all questions are provided to help you
                            cover every topic thoroughly and systematically.
                        </li>
                        <li className="mb-2">
                            <strong>Flexibility</strong> is provided to attempt the tests at your convenience.
                        </li>
                    </ul>
                </div>

                <div className='division-strip'>
                    Neet Test Series
                </div>

                <div className='AllCard_Box'>
                    {testSeries.map((card, index) => (
                        <div className="card Allcard AllDashboard" key={index}>
                            <Link to={`/neet/testseries/${card.TitleHeading}`} /* state={{ isEnrolled: card.isEnrolled }} */ className='text-decoration-none text-black'>
                                <img src={isValidUrl(card.Image) ? card.Image : aboutimg} className="card-img-top" alt={card.CourseTitle} style={{ height: "140px" }} />
                            </Link>
                            <div className="card-body All-bg">
                                <Link to={`/neet/testseries/${card.TitleHeading}`} /* state={{ isEnrolled: card.isEnrolled }} */ className='text-decoration-none text-black'>
                                    {card.CourseTitle ? <h6 className="fw-bold overflow-hidden" style={{}}>{card.CourseTitle}</h6> : <h6 className="fw-bold overflow-hidden" style={{}}>{card.Title}</h6>}
                                </Link>
                                <hr />
                                <div className="d-flex justify-content-between align-items-center">
                                    <Link to="#" className="card-link list-group-item">
                                        {card.TopicCount ? <h6 className='d-flex align-items-center'><BsJournals className='me-1' />{`${card.TopicCount} LESSONS`}</h6> : <h6 className='d-flex align-items-center'><BsJournals className='me-1' />{`${card.QuizCount || 0} Tests`}</h6>}
                                        {card.SubscriberCount && <h6 className='d-flex align-items-center'><FaUserFriends className='me-1' /> {card.SubscriberCount} SUBSCRIBERS</h6>}
                                    </Link>
                                    <Link to={`/neet/testseries/${card.TitleHeading}`} /* state={{ isEnrolled: card.isEnrolled }} */ className="btn-start list-group-item">START</Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className='AllCardBackground'>
                <div className='division-strip'>
                    Customised Test Series
                </div>
                <div className='AllCard_Box'>
                    {subjects.map((card, index) => (
                        <div className="card Allcard AllDashboard " key={index}>
                            <Link to={`/neet/dynamic-testseries/${card.Subject}`} state={{ subject: card.Subject, subjectId: card.Sn }} className='text-decoration-none text-black'>
                                {card.Thumbnail && <img src={card.Thumbnail} className="card-img-top" alt={card.Subject} style={{ height: "140px" }} />}
                            </Link>
                            <div className="card-body All-bg">
                                <Link to={`/neet/dynamic-testseries/${card.Subject}`} state={{ subject: card.Subject, subjectId: card.Sn }} className='text-decoration-none text-black'>
                                    <p className="fw-bold overflow-hidde fs-5 text-uppercase " >{card.Subject}</p>
                                </Link>
                                <hr />
                                <div className="d-flex justify-content-between align-items-center">
                                    <Link to="#" className="card-link list-group-item">
                                        {card.QuestionCount && <h6 className='d-flex align-items-center'><BsJournals className='me-1' />{`${card.QuestionCount} Questions`}</h6>}
                                        {card.Duration && <h6 className='d-flex align-items-center'><BsClock className='me-1' /> {card.Duration} Mins</h6>}
                                    </Link>
                                    <Link to={`/neet/dynamic-testseries/${card.Subject}`} state={{ subject: card.Subject, subjectId: card.Sn }} className="btn-start list-group-item">CHOOSE PLAN</Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>

    )
}

export default NeetTestSeriesCards